import { listDocs, getDoc, createDoc, updateDoc, deleteDoc } from './appDataClient';
import { pollingSubscription } from './adapters';

// Accounts and their permission links are stored through /api/app-data.

const ACCOUNTS = 'accounts';
const LINKS = 'permissionLinks';

// ===== Account CRUD =====

export const createAccount = async (accountData) =>
  createDoc(ACCOUNTS, { ...accountData, isActive: true, lastLoginAt: null });

export const getAccount = async (accountId) => getDoc(ACCOUNTS, accountId);

export const getAccountByUsername = async (username) => {
  const accounts = await listDocs(ACCOUNTS);
  return accounts.find((a) => a.username === username) || null;
};

export const getAllAccounts = async () => listDocs(ACCOUNTS);

export const updateAccount = async (accountId, updates) =>
  updateDoc(ACCOUNTS, accountId, updates);

// Removing an account also removes its permission links, which record the
// account as their parent.
export const deleteAccount = async (accountId) => deleteDoc(ACCOUNTS, accountId);

// ===== Permission links =====

export const createPermissionLink = async (linkData) =>
  createDoc(LINKS, { ...linkData, parentId: linkData.accountId || null });

export const getPermissionLinks = async (accountId) =>
  listDocs(LINKS, { parentId: accountId });

export const deletePermissionLink = async (linkId) => deleteDoc(LINKS, linkId);

// ===== Login =====

export const accountLogin = async (username) => {
  const account = await getAccountByUsername(username);

  if (!account) {
    throw new Error('帳號不存在');
  }
  if (account.isActive === false) {
    throw new Error('帳號已停用');
  }

  await updateAccount(account.id, { lastLoginAt: new Date().toISOString() });
  return account;
};

export const subscribeToAccount = (accountId, callback) =>
  pollingSubscription(() => getAccount(accountId), callback);

export const subscribeToAllAccounts = (callback) =>
  pollingSubscription(getAllAccounts, callback);

export const hasPermission = (account, feature) => {
  if (!account || !account.permissions) return false;

  // Admin has all permissions
  if (account.role === 'admin') return true;

  return account.permissions[feature] === true;
};

export const generateFeatureUrl = (baseUrl, feature, accountId) => {
  const routes = {
    query: `/data-query/${accountId}`,
    dashboard: `/dashboard-builder/${accountId}`,
    dataScreen: `/data-screen/${accountId}`,
    devices: `/devices`,
    timers: `/dashboard`,
    backup: `/data-backup/${accountId}`
  };

  return `${baseUrl}${routes[feature] || '/'}`;
};
